module.exports = __webpack_public_path__ + "static/media/dots.45fec6fd.svg";